import { logError } from '@zg-rentals/log-error';

declare global {
  interface Window {
    FB: {
      api: (path: string, callback: (userData: FBResponse['userData']) => void) => void;
    };
  }
}

type FBResponse = {
  userData?: {
    id: string;
    name: string;
    email: string;
  };
};

const loginUtils = {
  getEmailFromFB(response: FBResponse): Promise<FBResponse | void> {
    return new Promise<FBResponse>((resolve, reject) => {
      window.FB.api('/me?fields=id,name,email', (userData: FBResponse['userData']) => {
        if (typeof userData !== 'undefined') {
          response.userData = userData;
          resolve(response);
        } else {
          reject(new Error('window.FB.api failed'));
        }
      });
    }).catch((err) => {
      logError({ error: err as Error, context: 'FB Email Validate Error' });
    });
  },
  isCanadianUser(countryCode: string, email = ''): boolean {
    const emailParts = email.split('.');
    const topLevelDomain = emailParts[emailParts.length - 1];
    if (countryCode === 'ca' || topLevelDomain === 'ca') {
      return true;
    }
    return false;
  },
};

export default loginUtils;
